import { Middleware } from 'redux';
import * as Actions from '../actions';
import RootState from '../RootState';
import { Frame } from '../../data/Frame';
import Layer from '../../data/Layer';
import { isStoredAsset } from '../../utils';
import { Soundtrack } from '../../audio/Soundtrack';
import Storable from '../../data/Storable';
import { PictureFrame } from '../../data/PictureFrame';
import { isTemplateAsset } from 'utils/S3Utils';

const handler: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    const flyerState = (store.getState() as RootState).flyer;
    if (flyerState.id === null) {
      // was never saved
      next(action);
      return;
    }

    const urlsRemoved: string[] = [];

    const addAsset = (asset: Storable) => {
      if (
        isStoredAsset(asset) &&
        !isTemplateAsset(asset.url) &&
        urlsRemoved.indexOf(asset.url) === -1
      ) {
        urlsRemoved.push(asset.url);
      }
    };

    switch (action.type) {
      case Actions.REMOVE_FRAME: {
        const frame: Frame = action.frame;
        if (frame instanceof PictureFrame) {
          addAsset(frame as PictureFrame);
        }
        break;
      }
      case Actions.REPLACE_FRAME: {
        const frame: Frame = action.oldFrame;
        if (frame instanceof PictureFrame) {
          addAsset(frame as PictureFrame);
        }
        break;
      }
      case Actions.REMOVE_LAYER: {
        (action.layer as Layer).frames.forEach(frame => {
          if (frame instanceof PictureFrame) {
            addAsset(frame as PictureFrame);
          }
        });
        break;
      }
      case Actions.ADD_AUDIO:
      case Actions.REMOVE_SOUNDTRACK:
        if (flyerState.motionSource) {
          const soundtrack = flyerState.motionSource as Soundtrack;
          addAsset(soundtrack);
        }
        break;
      default:
        break;
    }

    next(action);

    if (!urlsRemoved.length) {
      return;
    }

    setTimeout(() => {
      store.dispatch({ type: Actions.DID_REMOVE_ASSETS, assets: urlsRemoved });
    }, 1);
  };

export default handler;



// WEBPACK FOOTER //
// ./src/state/side-effects/didRemoveAsset.ts